import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d9af40b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2d9af40b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9af40b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9af40b')) {
      api.createRecord('2d9af40b', component.options)
    } else {
      api.reload('2d9af40b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d9af40b&scoped=true", function () {
      api.rerender('2d9af40b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderTop/index.vue"
export default component.exports